import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { APP_CONTAINER_ID } from './app/consts';
const root = createRoot(document.getElementById(APP_CONTAINER_ID));
root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
